<template>
  <div class="px-4">
    <v-row>
      <v-col cols="10" sm="5">
        <autocomplete-cadu
          :items="listaAplicacoes"
          title="Aplicação"
          v-model="aplicacaoSelecionada"
        />
      </v-col>
      <v-col cols="auto" class="mt-6 pl-0">
        <button-search @click="pesquisarPorAplicacao" />
      </v-col>
      <v-row justify="end" no-gutters>
        <v-col cols="auto" class="mt-8">
          <button-cadu :block="$vuetify.breakpoint.xs" @click="showFiltro = true">FILTRAR</button-cadu>
        </v-col>
      </v-row>
    </v-row>

    <v-row>
      <v-col>
        <table-cadu
          v-if="!isLoading"
          class="gerenciamentoToken mt-8"
          nameTab="TabelaGerenciamentoToken"
          custom
          :loading="isLoading"
          :rowsHeader="rowsHeader"
          :rows="rows"
          :showFiltro="false"
          :showSelect="false"
          :showCheck="false"
          :disabledCheckAll="true"
          :disabledButtons="[false,true,false,false,false,true,false]"
          :texto="'+ adicionar token de aplicação'"
          @clickButton="value => clickButton(value)"
          @ordena="obj => changeOrdem(obj)"
        />
      </v-col>
    </v-row>

    <SucessoModalComToken
      :sucessType="typeToken"
      :showSucess="showSucesso"
      :tokenGenerate="tokenGenerate"
      @close="closeSucessoToken"
    />

    <SucessoModal
      :genericMessage="messageSucess"
      :showSucess="showSucessNormal"
      @close="closeSucessoNormal"
    />

    <versao-modal @salvarVersao="putRefreshToken" v-model="showModalRefresh" title="Deseja realmente renovar este token?" />
    <versao-modal @salvarVersao="putRefreshToken" v-model="showModalBloqueio" :width="720" title="Ao regerar o token, o antigo será inativado! Você tem certeza que deseja regerar este token?" />

    <component-loading style="height: 256px;" :value="isLoading" />
    <overlay-loading v-model="loadingOverlay"/>

    <ModalAdicionarToken v-model="showModal" ref="modalAdicionarToken" @finalizar="adicionarToken" />
    <ModalEditarValidade v-model="showModalEditar" :dadosAplicacao="dadosAplicacao" @finalizar="edit => finalizarEdicao(edit)"/>
    <FiltroGerenciamentoToken v-model="showFiltro" @filtrar="filtragem" />

    <error-modal
      v-model="error"
      :errObj="errObj"
    />
  </div>
</template>

<script>
import FiltroGerenciamentoToken from './FiltroGerenciamentoToken'
import ModalAdicionarToken from './ModalAdicionarToken'
import SucessoModalComToken from './SucessoModalComToken'
import ModalEditarValidade from './ModalEditarValidade'

import GerenciamentoToken from '../../../../../services/GerenciamentoToken/GerenciamentoToken'

export default {
  components: {
    FiltroGerenciamentoToken,
    ModalAdicionarToken,
    SucessoModalComToken,
    ModalEditarValidade
  },
  data () {
    return {
      tokenBearer: localStorage.getItem('tokenBearer'),
      listaAplicacoes: [],
      aplicacaoSelecionada: '',
      isLoading: false,
      loadingOverlay: false,

      // Filtro
      showFiltro: false,

      // Modal Adicionar
      showModal: false,

      // Modal Editar Validade token
      showModalEditar: false,
      dadosAplicacao: {},

      // Sucesso
      showSucesso: false,
      showSucessNormal: false,
      messageSucess: '',

      // Modal Refresh/Bloquea
      showModalBloqueio: false,
      showModalRefresh: false,
      tokenGenerate: '',
      type: '',

      // Ordenacao Tabela
      ordemProp: 'asc',
      ordenacaoNome: '',

      // Tabela
      rowsHeader: [
        { text: 'Aplicação', icon: 'repeat' },
        { text: 'Token' },
        { text: 'Data Geração', icon: 'repeat' },
        { text: 'Data Expiração', icon: 'repeat' },
        { text: 'Status', icon: 'repeat' }
      ],
      rows: [],
      idToken: -1,
      tituloModal: '',
      typeToken: '',

      // Filtragem
      dataFinalExpiracao: '',
      dataFinalGeracao: '',
      dataInicialExpiracao: '',
      dataInicialGeracao: '',
      status: null,

      // Erro
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },

  beforeMount () {
    this.getTokenAplicacao()
    this.getAplicacoes()
  },

  methods: {
    clickButton (obj) {
      const tipoBotao = {
        add: () => (this.showModal = true),
        edit: () => this.editarTokenAplicacao(obj.index),
        refresh: () => this.recarregarTokenAplicacao(obj.index)
      }

      return (tipoBotao[obj.type] || tipoBotao['add'])()
    },

    editarTokenAplicacao (index) {
      this.dadosAplicacao = this.rows[index]
      this.showModalEditar = true
    },

    recarregarTokenAplicacao (index) {
      this.showModalBloqueio = true
      this.idToken = index
      this.typeToken = 'REFRESHTOKEN'
    },

    adicionarToken (token) {
      this.typeToken = 'TOKEN'
      this.tokenGenerate = token
      this.showSucesso = true
    },

    finalizarEdicao (dataInativada) {
      this.messageSucess = dataInativada ? 'Data alterada com sucesso!' : 'Token inativado com sucesso!'
      this.showSucessNormal = true
    },

    changeOrdem (obj) {
      this.ordemProp = this.ordemProp === 'asc' ? 'desc' : 'asc'
      this.ordenacaoNome = this.rowsHeader[obj.index].text
      const res = () => {
        switch (obj.index) {
          case 0:
            return 'nome'
          case 2:
            return 'dataGeracao'
          case 3:
            return 'dataExpiracao'
          case 4:
            return 'dataExpiracao'
        }
      }
      this.ordenacaoNome = res()
      this.ordemProp = this.ordemProp
      this.getTokenAplicacao(this.getArgs())
    },

    pesquisarPorAplicacao () {
      this.limparOrdenacaoTabela()
      this.status = this.aplicacaoSelecionada ? 'TODOS' : ''
      this.getTokenAplicacao(this.getArgs())
    },

    filtragem (objetoFiltro) {
      this.aplicacaoSelecionada = objetoFiltro.aplicacao
      this.dataInicialGeracao = objetoFiltro.periodoGeracaoInicial
      this.dataFinalGeracao = objetoFiltro.periodoGeracaoFinal
      this.dataInicialExpiracao = objetoFiltro.periodoExpiracaoInicial
      this.dataFinalExpiracao = objetoFiltro.periodoExpiracaoFinal
      this.status = objetoFiltro.check
      this.getTokenAplicacao(this.getArgs())
    },

    async closeSucessoToken () {
      this.showSucesso = false
      await this.getTokenAplicacao(this.getArgs())
      await this.getAplicacoes()
    },

    async closeSucessoNormal () {
      this.showSucessNormal = false
      await this.getTokenAplicacao(this.getArgs())
    },

    getArgs () {
      let args = this.geradorParams(
        // ORDENAÇÃO
        {
          name: 'ordenacao',
          value: this.ordenacaoNome
        },
        {
          name: 'direcaoOrdenacao',
          value: this.ordemProp
        },
        {
          name: 'aplicacao',
          value: this.aplicacaoSelecionada
        },
        // Filtragem
        {
          name: 'dataFinalExpiracao',
          value: this.dataFinalExpiracao
        },
        {
          name: 'dataFinalGeracao',
          value: this.dataFinalGeracao
        },
        {
          name: 'dataInicialGeracao',
          value: this.dataInicialGeracao
        },
        {
          name: 'dataInicialExpiracao',
          value: this.dataInicialExpiracao
        },
        {
          name: 'status',
          value: this.status
        }
      )
      return args
    },

    async getTokenAplicacao (args = '') {
      this.isLoading = true
      let emailArea = new GerenciamentoToken(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await emailArea.getConsultaAplicacao(args)
        this.rows = response.data

        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    async putRefreshToken () {
      this.loadingOverlay = true
      let gerenciamento = new GerenciamentoToken(
        this.tokenBearer,
        this.$appConfig.config.API
      )
      try {
        let response = await gerenciamento.putRefreshToken(this.rows[this.idToken].id)
        this.showModalBloqueio = false
        this.tokenGenerate = response.data.token
        this.loadingOverlay = false
        this.showSucesso = true
      } catch (err) {
        this.showModalBloqueio = false
        this.loadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    async getAplicacoes () {
      let gerenciamento = new GerenciamentoToken(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await gerenciamento.getAplicacoes()
        this.listaAplicacoes = response.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    limparOrdenacaoTabela () {
      this.ordemProp = ''
      this.ordenacaoNome = ''
    },

    geradorParams (...params) {
      let str = ''
      for (let p of params) {
        if (p.value) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    }
  }
}
</script>

<style lang="sass">
.gerenciamentoToken > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.gerenciamentoToken > .table-cadu > .table
  max-height: 250px
  overflow: auto
  table
    width: 100%
</style>
